import Vue from 'vue'

Vue.filter('pluralize', function (numberOfItems: number, singularWord: string, pluralWord?: string): string {
  if (numberOfItems === 1) return singularWord
  if (pluralWord) return pluralWord
  return `${singularWord}s`
})